import { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import i18next from 'i18next';

class ELEMENT_CONTRACT_EXPENSE_BALANCE extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: t('data-lang-lbl-balance'),
          data: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.montoSaldo) : []) : [100, 60, 20, 0],
          color: "#84B681"
        },
        {
          name: t('data-lang-lbl-spent'),
          data: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.montoPagoAcum) : []) : [0, 20, 15, 0],
          color: "#406A9C"
        }
      ],
      options: {
        chart: {
          type: 'area'
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value !== null ? parseFloat(value.toFixed(2)).toLocaleString(i18next.language) : value;
            }
          },
        },
        xaxis: {
          categories: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null ? this.props.inputParam_ComponentContent.items.map(x => x.periodId.toString()) : []) : [t('data-lang-lbl-date') + ' 1', t('data-lang-lbl-date') + ' 2', t('data-lang-lbl-date') + ' 3', t('data-lang-lbl-date') + ' 4'],
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 5,
          hover: {
            sizeOffset: 3
          }
        },
      }
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_ComponentContent: PropTypes.object,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_ComponentContent: null,
    inputParam_UseFake: false,
  };

  renderContent() {
    return  <Row className='px-3 h-100'>
              <Col>
                <ReactApexChart options={this.state.options} series={this.state.series} type="area" height="100%" />
              </Col>
            </Row>
  }

  render() {
    return (
      <>
        {
          !this.props.inputParam_UseFake &&
          <Card className='h-100'>
            {
              !this.props.inputParam_HideHeader &&
              <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                  <b>{ this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle !== null ? this.props.inputParam_ComponentContent.boardComponentTitle : t('data-lang-boxname-behaviorgraph')}</b>
                  <div className='toolbar d-flex'>
                  </div>
                </Card.Title>
              </Card.Header>
            }
            <Card.Body className='px-1 h-100'>
              {this.renderContent()}
            </Card.Body>
          </Card>
        }
        {this.props.inputParam_UseFake && this.renderContent()}
      </>
    );
  }
}

export default ELEMENT_CONTRACT_EXPENSE_BALANCE;